import $ from "jquery";

function GetFinishedEvent() {
  var iniNum = 4; //初期表示件数
  var getNum = 5; //取得件数

  // 5件目以降は初期非表示
  $(".js-finished-event-item:nth-child(n + " + (iniNum + 1) + ")")
    .hide()
    .addClass("is-hidden");

  $(".js-finished-event-button").on("click", function () {
    var button = $(this),
      list = $(this).prev(".js-finished-event"),
      hiddenItem = list.children(".js-finished-event-item.is-hidden");

    hiddenItem.slice(0, getNum).removeClass("is-hidden").fadeIn();
    if (list.children(".js-finished-event-item.is-hidden").length === 0) {
      button.fadeOut(0);
    }
  });
}

export { GetFinishedEvent };
